import { profileVerified } from "assets";

import { ScrollArea, ScrollBar } from "components/ui/scroll-area";

import ImageUrl from "components/app/image-url/ImageUrl";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import SearchBar from "components/app/search-bar/SearchBar";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import { Separator } from "components/ui/separator";
import { Skeleton } from "components/ui/skeleton";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "components/ui/tooltip";
import { ArrowDown, Bell, BriefcaseBusiness, CornerDownRight, Ellipsis, MessageCircle, Moon, Plus, Settings, Sun, X } from "lucide-react";
import AlertWellcome from "pages/auth/alert/AlertWellcome";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logout, updateAuthToken } from "store/authSlice";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, RouteUrl, StatusMsg } from "utils";
import DialogSeeMorePage from "./dialog/DialogSeeMorePage";
import DailogCreateYourPage from "./dialog/DailogCreateYourPage";
import NotificationSkeleton from "./NotificationSkeleton";
import DialogSeeMoreShop from "./dialog/DialogSeeMoreShop";
import { useTranslation } from "react-i18next";
import { appendFriendUsers, setFriendUsers, setIsDialogCreateShopOpen, setIsDialogSeeMorePagesOpen } from "store/header";
import appStore from "store/appStore";
import { Button } from "components/ui/button";
import { UploadPostContentType } from "utils/enum/UploadPostContentType";
import { AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "components/ui/alert-dialog";
import InputHideShow from "components/app/function/InputHideShow";
import { BrowserDeviceInfo, convertDeviceInfoToMap, getBrowserDeviceInfo } from "utils/deviceInfo";
import { setIsLoadingIsSwitchPage } from "store/header";
import { Service } from "utils/services";
import { Card } from "components/ui/card";
import { SuggestionSearch } from "components/app/shrimmer/Shrimmer";
import { AppLog } from "services";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "components/app/dialog/dialog";
import { setRequestWorkflows, setUserShopPositions } from "store/businessSuiteSlice";

interface Header2Props {
  headerType: "businessSuite" | "profileSuite";
}

export default function Header2({ headerType }: Header2Props) {
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [loadingPage, setLoadingPage] = useState<boolean>(false);
  const [loadingShop, setLoadingShop] = useState<boolean>(false);
  const [loadingNoti, setLoadingNoti] = useState<boolean>(false);
  const [showSuggestions, setShowSuggestions] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const postID = searchParams.get("post_id");
  const [user, setUser] = useState<any>(localStorage.getItem("user"));
  const [userShop, setUserShop] = useState<any>(null);
  const [userPage, setUserPage] = useState<any>(null);
  const [notificationData, setNotificationData] = useState<any>(null);
  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null);
  const [loadingMoreNoti, setLoadingMoreNoti] = useState<boolean>(false);
  const { token, isAuthenticated } = useAppSelector((state) => state.auth);
  const [isOpenProfile, setIsOpenProfile] = useState<boolean>(false);
  const [categories, setCategories] = useState<[]>([]);
  const [searchTextShop, setSearchTextShop] = useState<string>("");
  const { userShops, userShopSelectedProfile } = useAppSelector((state) => state.businessSuite);

  const { t, i18n } = useTranslation();
  const lang = localStorage.getItem("lang");

  const { theme, toggleTheme } = appStore();

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [i18n, lang]);

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [i18n, lang]);

  const handleShowAlert = (link: string) => {
    if (!isAuthenticated && link !== "/") {
      setShowAlert(true);
    } else {
      navigate(`${link}`);
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, [user]);

  const fetchGetUserPageProfile = async () => {
    try {
      setLoadingPage(true);
      let url: string = "";
      url = RouteApi.getPageUser;
      url += `token=${token}`;

      const response = await RequestApi(url);
      if (response.status === "success") {
        setUserPage(response["pages"]);
      } else {
        AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchGetUserPageProfile]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingPage(false);
    }
  };

  const fetchGetUserShopProfile = async () => {
    try {
      setLoadingShop(true);
      let url: string = "";
      url = RouteApi.getShopUser;
      url += `token=${token}`;

      const response = await RequestApi(url);
      if (response.status === "success") {
        setUserShop(response["user_shops"]);
        setCategories(response["categories"]);
        dispatch(setRequestWorkflows(response["request_workflows"]));
        dispatch(setUserShopPositions(response["user_shop_positions"]));
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchGetUserShopProfile]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingShop(false);
    }
  };

  const fetchGetNotification = async (url: string) => {
    try {
      setLoadingNoti(true);

      const response = await RequestApi(url);
      if (response.status === "success") {
        setNotificationData((prevData: any) => {
          if (prevData) {
            return {
              ...prevData,
              data: [...prevData.data, ...response["notifications"].data],
            };
          } else {
            return response["notifications"];
          }
        });
        setNextPageUrl(response["notifications"].next_page_url);
      } else {
        AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchGetUserShopProfile]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingNoti(false);
    }
  };

  const onClickProfileAvatar = () => {
    if (isAuthenticated) {
      if (!userPage && !userShop) {
        fetchGetUserPageProfile();
        fetchGetUserShopProfile();
      }
    }
  };

  const onClickNotification = () => {
    if (isAuthenticated) {
      if (!notificationData) {
        fetchGetNotification(`${RouteApi.getNotification}token=${token}`);
      }
    }
  };

  const groupedNotifications = notificationData?.data
    ? notificationData.data.reduce((acc: any, noti: any) => {
        const date = noti.entry_datetime_human;
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(noti);
        return acc;
      }, {})
    : {};

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
    if (scrollTop + clientHeight >= scrollHeight && nextPageUrl && !loadingMoreNoti) {
      setLoadingMoreNoti(true);
      fetchGetNotification(nextPageUrl).finally(() => setLoadingMoreNoti(false));
    }
  };

  const contentClick = (data: any) => {
    if (data.target_type === "Inbox") {
    } else if (data.target_type === "View Profile") {
      window.location.href = "https://www.flipflop.cam/profile?id=" + data.sender_id + "&posts";
    } else if (data.target_type === "Follow Profile") {
    } else if (data.target_type === "Post") {
      const content = JSON.parse(data.notification_content);
      if (content.post_link) {
        window.location.href = content.post_link;
      } else {
        window.location.href = "https://www.flipflop.cam/post?post_id=" + content.provider_post_id;
      }
    }
  };

  const { userAuth } = useAppSelector((state) => state.auth);
  const [userDataClick, setUserDataClick] = useState<any>({});
  const [password, setPassword] = useState<string>("");
  const [isAlertTypingPassword, setIsAlertTypingPassword] = useState<boolean>(false);
  const { isLoadingIsSwitchPage, friendUsers } = useAppSelector((state) => state.header);
  const [deviceInfo, setDeviceInfo] = useState<BrowserDeviceInfo | null>(null);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [messageError, setMessageError] = useState<any>("");

  const onSubmit = async ({ page }: { page: any }) => {
    dispatch(setIsLoadingIsSwitchPage(true));
    setLoading(true);
    try {
      let data;
      let url: string = "";
      // Personal
      if (page.user_type === "Personal") {
        url = RouteApi.switchLogin;
        url += `token=${token}&username=${page.email}&password=${password}`;
        data = {
          device_data: deviceInfo === null ? "" : convertDeviceInfoToMap(deviceInfo!),
        };
      } else if (page.user_type === "Page") {
        url = RouteApi.switchAccount;
        url += `token=${token}`;
        data = {
          user: page,
          device_data: deviceInfo === null ? "" : convertDeviceInfoToMap(deviceInfo!),
        };
      }

      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            // setLoading(false);

            setLoading(false);
            const { token, user } = responses;
            localStorage.setItem("user", JSON.stringify(user));
            localStorage.setItem("jwt", token);
            localStorage.setItem("authentication_key", user["authentication_key"]);
            dispatch(updateAuthToken(token));
            navigate("/");
            window.location.href = "/";
          } else {
            dispatch(setIsLoadingIsSwitchPage(false));
            setLoading(false);
            setMessageError(responses.msg);
          }
        })
        .catch((err) => {
          dispatch(setIsLoadingIsSwitchPage(false));
          console.log(err.msg, "erro");
          setMessageError(err.msg);
        });
    } catch (error) {
      setMessageError(error);

      AppLog.show({
        message: `[onSubmit]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      // setLoadingMoreItem(null);
    }
  };

  useEffect(() => {
    setDeviceInfo(getBrowserDeviceInfo());
  }, []);

  const handleClickSwitchAccount = ({ page }: { page: any }) => {
    if (userAuth.account_id !== page.account_id) {
      setUserDataClick(page);
      if (page.user_type === "Personal") {
        setIsAlertTypingPassword(true);
      } else if (page.user_type === "Page") {
        dispatch(setIsLoadingIsSwitchPage(true));
        onSubmit({ page });
      }
    } else {
      navigate(`/profile?id=${page.id}&feed`);
    }
  };

  const handleClickPersonalSubmitForm = () => {
    onSubmit({ page: userDataClick });
  };

  const [isLaodingLogout, setIsLoadingLogout] = useState<boolean>(false);
  const [laodingInitSuggestionSearch, setLaodingInitSuggestionSearch] = useState<boolean>(false);

  const [searchTextInput, setSearchTextInput] = useState<string>("");
  const [message, setMessage] = useState<string>("");

  const getSuggestionSearch = async () => {
    setLaodingInitSuggestionSearch(true);
    try {
      const url = `${RouteApi.getSuggestionSearch}token=${token}`;
      const data = {
        search_text: searchTextInput,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLaodingInitSuggestionSearch(false);
        dispatch(setFriendUsers(response.records.data));
        if (response.records.data.length === 0) {
          setMessage("Nothing more to load!.");
        }
      }
    } catch (error) {
      setLaodingInitSuggestionSearch(false);
      AppLog.show({
        message: `[getSuggestionSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  useEffect(() => {
    if (searchTextInput) {
      getSuggestionSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextInput]);

  // -----------------------
  const [page, setPage] = useState(1); // or use scroll_tag if API uses that
  const [isFetching, setIsFetching] = useState(false);

  const fetchMoreData = async () => {
    setIsFetching(true);
    try {
      const url = `${RouteApi.getSuggestionSearch}token=${token}`;
      const data = {
        search_text: searchTextInput,
        page: page + 1,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        dispatch(appendFriendUsers(response.records.data)); // append
        setIsFetching(false);
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchMoreData]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setIsFetching(false);
    }
  };

  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  const handleScrollMore = () => {
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }
    scrollTimeoutRef.current = setTimeout(() => {}, 500);
    const container = scrollContainerRef.current;
    if (!container || isFetching) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    if (scrollTop + clientHeight >= scrollHeight - 100) {
      fetchMoreData();
    }
  };

  let filteredShops = userShops?.filter((user: any) => user.shop_name.toString().toLowerCase().includes(searchTextShop.toLowerCase()));

  return (
    <header
      id="header-public-profile-post"
      className="w-full shadow-md bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 ring-gray-950/5 dark:bg-white/10 fixed top-0 left-0 z-50"
    >
      <div className="flex items-center justify-between py-2 px-4 h-[80px]">
        <div className="flex">
          {["businessSuite"].includes(headerType) && (
            <Dialog>
              <DialogTrigger className="flex w-[310px]">
                <div className="flex items-center">
                  <ImageUrl src={userShopSelectedProfile?.picture} className="w-[40px] h-[40px] rounded-full" alt="" />
                  {/* Hide this text block on mobile */}
                  <div className="hidden lg:flex flex-col items-start justify-start ms-2">
                    <h1 className="font-semibold line-clamp-1 text-start">{userShopSelectedProfile?.shop_name}</h1>
                    <p className="text-sm text-muted-foreground line-clamp-1 text-start">{userShopSelectedProfile?.description}</p>
                  </div>
                </div>
              </DialogTrigger>
              <DialogContent className="z-50 max-w-[300px] md:max-w-[500px] lg:max-w-[700px]">
                <DialogHeader>
                  <DialogTitle>{t("See more shops")}</DialogTitle>
                  <DialogDescription>Explore all available shops in one place.</DialogDescription>
                </DialogHeader>
                <div>
                  <div className="mt-4">
                    <SearchBar name="SearhAccount" onValueChange={(result) => setSearchTextShop(result)} />
                  </div>
                  <div className="h-[400px] max-w-[300px] md:max-w-[500px] lg:max-w-[700px] mt-4">
                    {filteredShops ? (
                      <div id="scrollableDiv" className="h-[400px] overflow-y-auto custom-scrollbar">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-20">
                          {filteredShops?.map((user: any) => {
                            return (
                              <Card key={user.shop_id} className="rounded-md space-y-2">
                                <div className="cursor-pointer h-full relative overflow-hidden">
                                  {user.status === "Unpublished" && (
                                    <div className="absolute z-10 top-0 rounded-bl-md rounded-tr-md  right-0 bg-red-700 p-2 text-white text-center font-sans py-0.5 opacity-80 flex items-center">
                                      <span className="text-sm">{user.status}</span>
                                    </div>
                                  )}
                                  <div className="h-full w-full">
                                    <div className="flex flex-col h-full w-full justify-between">
                                      <DialogClose
                                        onClick={() => {
                                          navigate(`/shop-detail?id=${user?.shop_id}`);
                                        }}
                                      >
                                        <ImageUrlProfile className="w-full object-cover h-[200px] rounded-t-md" user={user} isThumbnail={false} />

                                        <div className="p-2">
                                          <div className="flex">
                                            <h1 className="font-semibold text-lg line-clamp-1">{user?.shop_name}</h1>
                                            {user?.is_verified === "Yes" ? (
                                              <div>
                                                <div className="flex items-center justify-center pt-0.5 ml-1">
                                                  <img
                                                    src={profileVerified}
                                                    style={{
                                                      width: 24,
                                                      height: 24,
                                                    }}
                                                    alt=""
                                                  />
                                                </div>
                                              </div>
                                            ) : (
                                              <></>
                                            )}
                                          </div>
                                          <p className={`line-clamp-1 ${user?.description === "" ? "invisible" : ""}`}>{user?.description !== "" ? user?.description : "NoBio"}</p>
                                        </div>
                                      </DialogClose>

                                      <div className="grid grid-cols-1 p-2">
                                        <Button size={"sm"} className="text-white">
                                          View Shop
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Card>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </DialogContent>
            </Dialog>
          )}

          {["profileSuite"].includes(headerType) && (
            <div className="flex items-center w-[295px]">
              <ImageUrl src={user?.picture} className="w-[40px] h-[40px] rounded-full" alt="" />
              {/* Hide this text block on mobile */}
              <div className="flex flex-col items-start justify-start ms-2">
                <h1 className="font-semibold line-clamp-1 text-start">{user?.name}</h1>
                <p className="text-sm text-muted-foreground line-clamp-1 text-start">{user?.bio}</p>
              </div>
            </div>
          )}
        </div>
        {/* ---------------------Search bar-------------------------*/}
        {showSuggestions && <div className="absolute left-0 bg-black/80 backdrop-blur h-[100vh] top-[80px] w-full"></div>}

        {/* screen ipad 890  */}
        {window.innerWidth <= 890 && (
          <div className="">
            {showSuggestions && (
              <div
                onWheel={(e) => {
                  e.stopPropagation();
                }}
                className="absolute top-full left-0 w-full border mt-1 rounded-lg shadow z-50 dark:bg-[#020817] bg-white max-h-[800px] overflow-y-auto p-1"
              >
                <div
                  onWheel={(e) => {
                    e.stopPropagation();
                  }}
                  className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-8"
                >
                  {laodingInitSuggestionSearch ? (
                    <>
                      {friendUsers?.map((user: any, index: number) => (
                        <Card key={index} className="rounded-md animate-pulse">
                          <div className="w-full h-[200px]  rounded-t-md" />

                          <div className="p-2 space-y-2">
                            <div className="flex items-center space-x-2">
                              <div className="w-32 h-5  rounded" />
                              <div className="w-6 h-6  rounded-full" />
                            </div>
                            <div className="w-40 h-4  rounded" />
                          </div>

                          <div className="grid grid-cols-3 text-center px-4 py-2 gap-2">
                            <div>
                              <Skeleton className="w-12 h-3 mx-auto  rounded mt-1" />
                              <Skeleton className="w-12 h-3 mx-auto  rounded mt-1" />
                            </div>
                            <div>
                              <Skeleton className="w-12 h-3 mx-auto  rounded mt-1" />
                              <Skeleton className="w-12 h-3 mx-auto  rounded mt-1" />
                            </div>
                            <div>
                              <Skeleton className="w-12 h-3 mx-auto  rounded mt-1" />
                              <Skeleton className="w-12 h-3 mx-auto  rounded mt-1" />
                            </div>
                          </div>

                          <div className="p-2">
                            <Skeleton className="w-full h-10  rounded" />
                          </div>
                        </Card>
                      ))}
                    </>
                  ) : (
                    <>
                      {friendUsers?.map((user: any, index: number) => {
                        return (
                          <Card key={index} className="rounded-md">
                            <div
                              className="cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/profile?id=${user?.id}&feed`);
                              }}
                            >
                              <ImageUrlProfile className="w-full object-cover h-[200px] rounded-t-md" user={user} isThumbnail={false} />
                              <div className="p-2">
                                <div className="flex">
                                  <h1 className="font-semibold text-lg line-clamp-1">{user?.name}</h1>
                                  {user?.is_verified === "Yes" ? (
                                    <div className="flex items-center justify-center pt-0.5 ml-1">
                                      <img src={profileVerified} style={{ width: 24, height: 24 }} alt="" />
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                <p className={`line-clamp-1 ${user?.bio === "" ? "invisible" : ""}`}>{user?.bio !== "" ? user?.bio : "NoBio"}</p>
                              </div>
                            </div>

                            <div className="grid grid-cols-3 text-center">
                              <div className="">
                                <h1 className="font-semibold">{user?.no_of_follower}</h1>
                                <p className="text-xs">Followers</p>
                              </div>
                              <div className="">
                                <h1 className="font-semibold">{user?.no_of_post}</h1>
                                <p className="text-xs">Posts</p>
                              </div>
                              <div className="">
                                <h1 className="font-semibold">{user?.no_of_like}</h1>
                                <p className="text-xs">Likes</p>
                              </div>
                            </div>

                            {/* {user?.friend_status && (
                              <div className="grid grid-cols-1 p-2">
                                <BtnFriendStatus friendStatus={user?.friend_status} onClick={() => onClickFriend({ user, isArray: true })} userType={user?.user_type} />
                              </div>
                            )} */}
                          </Card>
                        );
                      })}
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* ---------------------End Search bar---------------------*/}

        <div className="flex items-center">
          {/* ==== Notification ==== */}
          <Popover>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <PopoverTrigger
                    className="z-50 hover:bg-gray-200  dark:hover:bg-primary rounded-full w-12 h-12 p-3"
                    asChild
                    onClick={() => {
                      onClickNotification();
                      setIsOpenProfile(true);
                    }}
                  >
                    <Bell className="cursor-pointer" />
                  </PopoverTrigger>
                </TooltipTrigger>
                <TooltipContent>
                  <p>{t("Notification")}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
            <PopoverContent className="w-[400px] h-[830px] mr-5">
              <ScrollArea onWheel={(e) => e.stopPropagation()} className="mt-2 w-full h-full" onScroll={handleScroll}>
                <div className="">
                  <div className="space-y-2">
                    <h4 className="font-medium text-center ">{t("Notification")}</h4>
                    <div className="  overflow-auto p-2">
                      {Object.keys(groupedNotifications).map((date: string) => (
                        <div key={date}>
                          <h1 className="font-semibold text-lg">{date}</h1>{" "}
                          {groupedNotifications[date].map((noti: any, indexPage: number) => (
                            <div key={indexPage}>
                              <div onClick={() => contentClick(noti)} className="hover:bg-gray-200  dark:hover:bg-primary rounded-xl p-2">
                                <div className="flex justify-between items-center">
                                  <div className="flex items-center">
                                    <ImageUrl className="w-[42px] h-[42px] object-contain rounded-full mr-2 " src={noti.sender.picture} alt="pic" />
                                    <p className="text-sm">{noti.title}</p>
                                  </div>
                                  {noti.picture && <ImageUrl className="w-auto h-[72px] object-contain rounded-sm" src={noti.picture} alt="pic" />}
                                </div>
                              </div>
                            </div>
                          ))}
                          <div className="mb-[15px]"></div>
                        </div>
                      ))}
                    </div>
                    {loadingNoti && (
                      <div className="space-y-4">
                        <NotificationSkeleton />
                      </div>
                    )}
                  </div>
                </div>
                <ScrollBar orientation="vertical" />
              </ScrollArea>
            </PopoverContent>
          </Popover>

          {/* ==== Message ==== */}
          <Popover>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger className="hover:bg-gray-200  dark:hover:bg-primary rounded-full w-12 h-12 p-3" asChild>
                  <PopoverTrigger asChild>
                    <MessageCircle className="cursor-pointer" />
                  </PopoverTrigger>
                </TooltipTrigger>
                <TooltipContent>
                  <p>{t("Messages")}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
            <PopoverContent className="w-80">
              <div className="grid gap-4">
                <div className="space-y-2">
                  <h4 className="font-medium">{t("Messages")}</h4>
                  <p className="text-sm text-muted-foreground hidden">Set the dimensions for the layer.</p>
                </div>
              </div>
            </PopoverContent>
          </Popover>

          {/* switch theme */}
          <div className="flex justify-center items-center">
            {theme === "light" ? (
              <Sun
                onClick={toggleTheme}
                className={`transition-all hover:bg-gray-200 dark:hover:bg-primary rounded-full w-12 h-12 p-3 ${theme === "light" ? "rotate-0 scale-100" : "-rotate-90 scale-0"}`}
              />
            ) : (
              <Moon
                onClick={toggleTheme}
                className={`transition-all hover:bg-gray-200 dark:hover:bg-primary rounded-full w-12 h-12 p-3 ${theme === "dark" ? "rotate-0 scale-100" : "rotate-90 scale-0"}`}
              />
            )}
          </div>

          {/* ==== Profile ==== */}
          {isAuthenticated ? (
            <Popover>
              <PopoverTrigger
                onClick={() => {
                  setIsOpenProfile(true);
                  onClickProfileAvatar();
                }}
                className="z-50 hover:bg-accent hover:text-accent-foreground dark:hover:bg-primary rounded-full w-12 h-12 p-2"
              >
                <ImageUrlProfile isLinkProfile={false} user={user} className="rounded-full" alt="logo" />
              </PopoverTrigger>
              {/* do it */}
              <PopoverContent className="w-[300px]">
                <div className="">
                  <div className="">
                    <div className="space-y-1">
                      <h1 className="font-semibold">{t("Accounts & Pages ")}</h1>

                      {loadingPage && (
                        <>
                          {[...Array(1)].map((_, index) => {
                            return (
                              <div key={index} className="flex items-center p-2">
                                <Skeleton className="w-8 h-8 rounded-full" />
                                <Skeleton className="w-40 h-6 ml-2" />
                              </div>
                            );
                          })}
                        </>
                      )}
                      {/* this */}
                      {userPage?.data.length > 0 ? (
                        <>
                          {userPage?.data?.slice(0, 2).map((page: any, indexPage: number) => {
                            return (
                              <div
                                key={indexPage}
                                onClick={() => {
                                  // setIsOpenProfile(false);
                                  // navigate(`/profile?id=${page.id}&posts`);
                                  handleClickSwitchAccount({ page });
                                }}
                                className="relative  flex flex-row cursor-pointer bg-slate-50 hover:bg-slate-100 dark:bg-background dark:hover:bg-slate-900 w-full p-2 rounded-lg overflow-hidden"
                              >
                                {page.status === "Unpublished" && (
                                  <div className="absolute z-10 top-0 rounded-bl-md rounded-tr-md right-0 bg-red-700 p-2 text-white text-center font-sans py-0.5 opacity-80 flex items-center">
                                    <span className="text-xs">{page.status}</span>
                                  </div>
                                )}

                                <div className="flex items-center">
                                  <ImageUrlProfile isLinkProfile={false} user={page} className="w-8 h-8 rounded-full border" />
                                  <div className="flex flex-col justify-center items-start ml-2">
                                    <div className="flex items-center justify-between">
                                      <h4 className="font-medium line-clamp-1">{page.name}</h4>
                                      {user?.is_verified === "Yes" ? (
                                        <>
                                          <img
                                            src={profileVerified}
                                            alt=""
                                            className="ml-1"
                                            style={{
                                              width: 16,
                                              height: 16,
                                            }}
                                          />
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                    <h5 className="text-muted-foreground text-xs line-clamp-1">{page.bio}</h5>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </>
                      ) : (
                        <></>
                      )}
                      <button
                        onClick={() => {
                          dispatch(setIsDialogSeeMorePagesOpen(true));
                        }}
                        className="flex items-center justify-start flex-row cursor-pointer hover:bg-slate-200 dark:bg-background dark:hover:bg-slate-900 w-full p-2 rounded-lg"
                      >
                        <div className="w-8 h-8 rounded-full border flex justify-center items-center bg-gray-200 dark:bg-background dark:hover:bg-slate-900">
                          <Ellipsis />
                        </div>
                        <p className="ml-2 font-medium ">{t("See more pages")}</p>
                      </button>
                      <DialogSeeMorePage />
                      {user.user_type === "Personal" && (
                        <>
                          <DailogCreateYourPage categories={categories} />
                        </>
                      )}

                      {user.user_type === "Personal" && (
                        <>
                          <h1 className="font-semibold">{t("Shops")}</h1>
                          {userShop?.length > 0 ? (
                            <>
                              {userShop?.slice(0, 2).map((shop: any, indexShop: number) => {
                                return (
                                  <div
                                    key={indexShop}
                                    onClick={() => {
                                      setIsOpenProfile(false);
                                      navigate(`${RouteUrl.businessSuite}?id=${shop.shop_id}`);
                                    }}
                                    className="relative flex flex-row cursor-pointer bg-slate-50 hover:bg-slate-100 dark:bg-background dark:hover:bg-slate-900 w-full p-2 rounded-lg"
                                  >
                                    {shop.status === "Unpublished" && (
                                      <div className="absolute z-10 top-0 rounded-bl-md rounded-tr-md right-0 bg-red-700 p-2 text-white text-center font-sans py-0.5 opacity-80 flex items-center">
                                        <span className="text-xs">{shop.status}</span>
                                      </div>
                                    )}

                                    <div className="flex items-center">
                                      <ImageUrl src={shop?.thumbnail} className="w-8 h-8 rounded-full border" />
                                      <div className="flex flex-col justify-center items-start ml-2">
                                        <div className="flex items-center justify-between">
                                          <h4 className="font-medium line-clamp-1">{shop?.shop_name}</h4>
                                          {user?.is_verified === "Yes" ? (
                                            <>
                                              <img
                                                src={profileVerified}
                                                alt=""
                                                className="ml-1"
                                                style={{
                                                  width: 16,
                                                  height: 16,
                                                }}
                                              />
                                            </>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                        <h5 className="text-muted-foreground text-xs line-clamp-1">{shop.shop_category}</h5>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </>
                          ) : (
                            <></>
                          )}
                          <DialogSeeMoreShop userShop={userShop} />
                          <div onClick={() => dispatch(setIsDialogCreateShopOpen(true))} className="">
                            <div className="flex items-center justify-start flex-row cursor-pointer hover:bg-slate-200 dark:bg-background dark:hover:bg-slate-900 w-full p-2 rounded-lg">
                              <div className="w-8 h-8 rounded-full border flex justify-center items-center bg-gray-200 dark:bg-background dark:hover:bg-slate-900">
                                <Plus />
                              </div>
                              <button className="ml-2 font-medium">{t("Create your shop")}</button>
                            </div>
                          </div>
                        </>
                      )}

                      <Separator className="" />
                      <div
                        onClick={() => navigate(RouteUrl.ProfileDetail)}
                        className="flex flex-row cursor-pointer hover:bg-slate-200 dark:bg-background dark:hover:bg-slate-900 w-full p-2 rounded-lg"
                      >
                        <Settings className="" />
                        <p className="pl-2 font-medium">{t("Setting & Account")}</p>
                      </div>

                      {user.user_type === "Personal" && (
                        <div
                          onClick={() => {
                            if (user.last_active_shop_id) {
                              navigate(`${RouteUrl.businessSuite}?id=${user.last_active_shop_id}`);
                            } else {
                              dispatch(setIsDialogCreateShopOpen(true));
                            }
                          }}
                          className="flex flex-row cursor-pointer hover:bg-slate-200 dark:bg-background dark:hover:bg-slate-900 w-full p-2 rounded-lg"
                        >
                          <BriefcaseBusiness className="" />
                          <p className="pl-2 font-medium">{t("Business Suite")}</p>
                        </div>
                      )}
                      <div
                        className="flex flex-row text-red-500 text-muted-foreground cursor-pointer hover:bg-slate-200 dark:bg-background dark:hover:bg-slate-900 w-full p-2 rounded-lg"
                        onClick={async () => {
                          setIsLoadingLogout(true);

                          // * ---- NEW CODE JK ---- * //
                          let url = RouteApi.logout;
                          url += `token=${Service.token}`;

                          const respone = await RequestApi(url);
                          if (respone.status === "success") {
                          } else {
                            AppLog.log(respone.msg);
                          }

                          setTimeout(() => {
                            dispatch(logout());
                            window.location.href = "/";
                          }, 3000);
                        }}
                      >
                        <CornerDownRight className="" />
                        <p className="pl-2 font-medium">{t("Logout")}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          ) : (
            <div onClick={() => setShowAlert(true)} className="hover:bg-gray-200 rounded-full w-12 h-12 p-2">
              <div className="">
                <ImageUrlProfile isLinkProfile={false} user={user} className="cursor-pointer rounded-full" alt="logo" />
              </div>
            </div>
          )}
        </div>
      </div>

      <AlertWellcome showAlert={showAlert} setShowAlert={setShowAlert} />

      <AlertDialog open={isAlertTypingPassword}>
        <form>
          <AlertDialogContent>
            <AlertDialogHeader className="relative">
              <AlertDialogTitle></AlertDialogTitle>
              <X
                onClick={() => {
                  setIsAlertTypingPassword(false);
                  setMessageError("");
                }}
                className="absolute top-0 right-0 cursor-pointer"
              />
            </AlertDialogHeader>
            <div className="flex justify-center items-center flex-col space-y-2">
              <ImageUrlProfile className="rounded-full w-[100px] h-[100px]" user={userDataClick} />
              <p className="font-semibold text-xl">{userDataClick.name}</p>
              <p className=" text-sm pb-10 ">{userDataClick.bio}</p>
              <div className="w-full mt-2">
                <InputHideShow
                  placeholder="Password"
                  onChange={(event) => {
                    setPassword(event.target.value);

                    setMessageError("");
                  }}
                />
              </div>
              {messageError && <p className="text-red-500 text-start">{messageError}</p>}
            </div>
            <AlertDialogFooter>
              <AlertDialogAction onClick={handleClickPersonalSubmitForm} className="text-white w-full">
                Continue
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </form>
      </AlertDialog>
      {/* <DailogSwitchAccountOrPage userDataClick={userDataClick} /> */}

      {/* dailog switch page or account */}
      <AlertDialog open={isLoadingIsSwitchPage}>
        <form>
          <AlertDialogContent>
            <AlertDialogHeader className="relative">
              <AlertDialogTitle></AlertDialogTitle>
            </AlertDialogHeader>
            <div className="flex justify-center items-center flex-col space-y-2">
              <ImageUrlProfile className="rounded-full w-[100px] h-[100px]" user={userDataClick} />
              <p className="font-semibold text-xl">{userDataClick.name}</p>
              <p className=" text-sm pb-10 ">{userDataClick.bio}</p>
              <svg className="size-6 animate-bounce ">
                <ArrowDown className=" font-semibold" />
              </svg>
              <p className=" text-sm font-semibold pb-10">{userDataClick.user_type === "Personal" ? " Switching Account..." : "Switching Page..."}</p>
            </div>
          </AlertDialogContent>
        </form>
      </AlertDialog>

      {/* dailog logout account */}
      <AlertDialog open={isLaodingLogout}>
        <form>
          <AlertDialogContent>
            <AlertDialogHeader className="relative">
              <AlertDialogTitle></AlertDialogTitle>
            </AlertDialogHeader>
            <div className="flex justify-center items-center flex-col space-y-2">
              <ImageUrlProfile className="rounded-full w-[100px] h-[100px]" user={userAuth} />
              <p className="font-semibold text-xl">{userAuth?.name}</p>
              <p className=" text-sm pb-10 ">{userAuth?.bio}</p>
              <svg className="size-6 animate-bounce ">
                <ArrowDown className=" font-semibold" />
              </svg>
              <p className=" text-sm font-semibold pb-10 ">Logging out account...</p>
            </div>
          </AlertDialogContent>
        </form>
      </AlertDialog>
    </header>
  );
}
